export const manifest = {
  screens: {
    scr_iicbu3: { name: "Admin Dashboard", route: "/menu-management", position: {"x":160,"y":220} },
    scr_z88j1x: { name: "Report", route: "/", position: {"x":160,"y":4180} },
    scr_4kdfp5: { name: "Orders", route: "/orders", position: {"x":160,"y":6160} },
    scr_qb9j5a: { name: "Kitchen (KDS)", route: "/kitchen", position: {"x":1560,"y":6160} },
    scr_yq4mbm: { name: "Branches", route: "/branches", position: {"x":1560,"y":220} },
    scr_wizy0o: { name: "Settings", route: "/settings", position: {"x":2960,"y":220} },
    scr_ukk2en: { name: "Customer Menu", route: "/menu", position: {"x":160,"y":2200} },
    scr_d4cbbn: { name: "Checkout (Tipping)", route: "/checkout-preview", position: {"x":1560,"y":2200} },
    scr_29rdac: { name: "CRM", route: "/crm", position: {"x":160,"y":8140} },
    scr_yjfsvn: { name: "Outlet · Main Dining", route: "/menu?outlet=o_main", position: {"x":2960,"y":2200} },
    scr_nlhaay: { name: "Outlet · Skylight Bar", route: "/menu?outlet=o_bar", position: {"x":4360,"y":2200} },
    scr_r4hgt1: { name: "Outlet · Asian Fusion", route: "/menu?outlet=o_asian", position: {"x":5760,"y":2200} },
    scr_22zxvu: { name: "Login / Sign up", route: "/login", position: {"x":160,"y":10120} },
    scr_2veajb: { name: "Welcome · Home", route: "/welcome", position: {"x":160,"y":12100} },
    scr_n6pd2v: { name: "Welcome · Select Location", route: "/welcome", state: {"sheet":"menu"}, position: {"x":1560,"y":12100} },
    scr_bayb8n: { name: "Welcome · Contact Us", route: "/welcome", state: {"sheet":"contact"}, position: {"x":2960,"y":12100} },
    scr_9n0x8t: { name: "Welcome · Home (Guest)", route: "/welcome", state: {"authPreview":"guest"}, position: {"x":4360,"y":12100} },
    scr_b2i6qf: { name: "Admin · Feedback", route: "/feedback", position: {"x":1560,"y":14080} },
    scr_diitm6: { name: "Customer · Leave Feedback", route: "/leave-feedback", position: {"x":160,"y":14080} },
  },
  sections: {
    sec_fmmxem: { name: "Admin Dashboard", x: 0, y: 0, width: 4320, height: 1180 },
    sec_a1v404: { name: "Customer Menu", x: 0, y: 1980, width: 11320, height: 1180 },
    sec_ekwsnb: { name: "Report", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_nqwfx6: { name: "Orders Management", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_pfcjx8: { name: "CRM Management", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_c8lg0o: { name: "Authentication", x: 0, y: 9900, width: 1520, height: 1180 },
    sec_7wgnwe: { name: "Welcome Onboarding", x: 0, y: 11880, width: 5720, height: 1180 },
    sec_ocor3w: { name: "Feedback Management", x: 0, y: 13860, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_fmmxem", children: [
      { kind: "screen", id: "scr_iicbu3" },
      { kind: "screen", id: "scr_yq4mbm" },
      { kind: "screen", id: "scr_wizy0o" },
    ] },
    { kind: "section", id: "sec_a1v404", children: [
      { kind: "screen", id: "scr_ukk2en" },
      { kind: "screen", id: "scr_d4cbbn" },
      { kind: "screen", id: "scr_yjfsvn" },
      { kind: "screen", id: "scr_nlhaay" },
      { kind: "screen", id: "scr_r4hgt1" },
    ] },
    { kind: "section", id: "sec_ekwsnb", children: [
      { kind: "screen", id: "scr_z88j1x" },
    ] },
    { kind: "section", id: "sec_nqwfx6", children: [
      { kind: "screen", id: "scr_4kdfp5" },
      { kind: "screen", id: "scr_qb9j5a" },
    ] },
    { kind: "section", id: "sec_pfcjx8", children: [
      { kind: "screen", id: "scr_29rdac" },
    ] },
    { kind: "section", id: "sec_c8lg0o", children: [
      { kind: "screen", id: "scr_22zxvu" },
    ] },
    { kind: "section", id: "sec_7wgnwe", children: [
      { kind: "screen", id: "scr_2veajb" },
      { kind: "screen", id: "scr_n6pd2v" },
      { kind: "screen", id: "scr_bayb8n" },
      { kind: "screen", id: "scr_9n0x8t" },
    ] },
    { kind: "section", id: "sec_ocor3w", children: [
      { kind: "screen", id: "scr_diitm6" },
      { kind: "screen", id: "scr_b2i6qf" },
    ] },
  ],
}
